export enum Network {
  Polkadot = 0,
  Kusama = 1,
  Westend = 2,
}
